import React from 'react';
import styled, { keyframes } from 'styled-components';
import { commonStyles } from '../../theme';

const modalSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
  touch-action: none;
`;

const ModalContent = styled.div`
  background-color: ${commonStyles.secondaryBackground};
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  width: 50vw;
  min-height: 20vh;
  max-height: 90vh;
  overflow: hidden;
  animation: ${modalSlideIn} 0.3s ease-out;
  
  @media (max-width: 480px) {
    width: 80vw;
    margin: 20px;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px;
  border-bottom: 1px solid ${commonStyles.primaryBorder};
  
  @media (max-width: 480px) {
    padding: 16px 20px 12px;
  }
`;

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: ${commonStyles.primaryText};
  
  @media (max-width: 480px) {
    font-size: 1.25rem;
  }
`;

const ModalClose = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  color: ${commonStyles.mutedText};
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: var(--bg-tertiary);
    color: ${commonStyles.secondaryText};
  }

  &:focus {
    outline: 2px solid var(--focus-color);
    outline-offset: 2px;
  }
`;

const ModalBody = styled.div`
  padding: 24px 28px;
  
  @media (max-width: 480px) {
    padding: 20px;
  }
`;

const Modal = ({ isOpen, onClose, children, title, showCloseButton = true }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent>
        <ModalHeader>
          {title && <ModalTitle>{title}</ModalTitle>}
          {showCloseButton && (
            <ModalClose 
              onClick={onClose}
              aria-label="Close modal"
            >
              ×
            </ModalClose>
          )}
        </ModalHeader>
        <ModalBody>
          {children}
        </ModalBody>
      </ModalContent>
    </ModalOverlay>
  );
};

export default Modal;
